/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const PurchaseOrderDetail = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/PurchaseOrderDetail",
      // top: "1",
      filter: `PurchaseOrderCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/PurchaseOrderDetail";
    return ApiService.createDataSource(url, params);
  },
};

export { PurchaseOrderDetail };
